import React from "react";
import styled from "styled-components";
import OrderHistoryDetails from "./OrderHistoryDetails";
import { useTranslation } from "react-i18next";
import { Breakpoint } from "@arcteryx/components-typography";
import { Button } from "@arcteryx/components-button";

const Footer = styled.div`
  width: 100%;
  padding: 0px;
  padding-top: 2em;
  display: flex;
  justify-content: ${props => `${props.returnUrl ? "space-between" : "flex-end"}`};
  flex-direction: row;
  ${Breakpoint("md")`
    flex-direction: row;
    border-top: 1px solid var(--colour-grey-pinline);
  `}
  ${Breakpoint("sm")`
    flex-direction: row;
    border-top: 1px solid var(--colour-grey-pinline);
  `}
  ${Breakpoint("xs")`
    flex-direction: column-reverse;
    border-top: 2px solid var(--colour-black);
    padding-top: 1em;
    margin-top: initial;
    margin-bottom: 20px;
  `}
`;

const ReturnCTA = styled(Button)`
  ${Breakpoint("xs")`
    margin-bottom: 20px;
  `}
`;

const OrderHistoryFooter = ({ order, returnUrl }) => {
  const { t } = useTranslation("components-order-history");

  const handleOnClick = () => {
    window.open(returnUrl, "_blank");
  };
  return (
    <Footer returnUrl={returnUrl}>
      {returnUrl && (
        <ReturnCTA context="Standard" onClick={handleOnClick}>
          {t("Start/View a Return")}
        </ReturnCTA>
      )}
      <OrderHistoryDetails
        subTotal={order?.subTotal}
        taxes={order?.taxes}
        currency={order?.currency}
        total={order?.total}
      />
    </Footer>
  );
};

export default OrderHistoryFooter;
